import { InternationalizationHelper } from "../helpers/InternationalizationHelper";
import { Config } from "./Config";
import { Global } from "./Global";

export class BaseComponent {

  constructor() {
  }

  showAds = Config.showAds;

  drawerIsOpen = false;

  getString(key: string, placeholders?: Record<string, string>): string {
    let internationalizedString = InternationalizationHelper.getString(key);

    if (internationalizedString === "") {
      internationalizedString = key;
    }

    if (placeholders) {
      for (const [placeholder, value] of Object.entries(placeholders)) {
        internationalizedString = internationalizedString.replace(`{${placeholder}}`, value);
      }
    }

    return internationalizedString;
  }

  getStore(): string {
    return Global.getStore();
  }

  getCountry(): string {
    return Global.getCountry();
  }

  toggleDrawer() {
    this.drawerIsOpen = !this.drawerIsOpen;
  }

  isRouteActive(urlPart: string): boolean {
    const stringRoute = location ? location.pathname.toString() : "";
    if (stringRoute) {
      if (urlPart === this.getString('onSaleUrl')) {
        if (stringRoute.indexOf(urlPart) > -1) {
          return true;
        }
        else {
          for (const store of Global.lists) {
            for (const category of store.categories) {
              for (const item of category.items) {
                if (stringRoute.indexOf(item.url) > -1) {
                  return true;
                }
              }
            }
          }
        }
      }
      return stringRoute.indexOf(urlPart) > -1;
    }
    else {
      return false;
    }
  }

  getListTypes(): Array<any> {
    return [
      { key: "wishlist", labelKey: "wishlist", urlKey: "wishlistUrl", icon: "star" },
      { key: "my-purchases", labelKey: "myPurchases", urlKey: "myPurchasesUrl", icon: "check_circle_outline" },
      { key: "my-lists", labelKey: "myLists", urlKey: "myListsUrl", icon: "format_list_bulleted" },
      { key: "blocklist", labelKey: "blocklist", urlKey: "blocklistUrl", icon: "block" }
    ];
  }

  getListTypeUrl(listType: any): string {
    const mediaType = Global.getMediaTypeForWishlistRequest();
    return "/" + [
      Global.getCountry(),
      Global.getStoreUrl(),
      this.getString(mediaType + "Url"),
      this.getString(listType.urlKey)
    ].join("/");
  }

  getListTypeLabelParts(listType: any): string[] {
    const label = this.getString(listType.labelKey);
    if (listType.key === "my-purchases" || listType.key === "my-lists") {
      return label.split(" ");
    }
    return [label];
  }

  isActiveListType(listType: any): boolean {
    const stringRoute = location ? location.pathname.toString() : "";
    const parts = stringRoute.split("/");
    return parts.indexOf(this.getString(listType.urlKey)) > -1;
  }

}
